
export async function bookingBizum(cart, data, merchantURL, debug=false){

  if (debug) console.log("[VTCartForm]-> PAYMENT BIZUM");
  if (debug) console.log("cart",cart);
  if (debug) console.log("data",data);
  if (debug) console.log("merchantURL",merchantURL);
  if (debug) console.log("URL",process.env.API_URL+"bookingBizum");

  const postdata = new FormData();
  postdata.append('cartcontent',JSON.stringify(cart));
  postdata.append('formdata',JSON.stringify(data));
  postdata.append('merchantURL',JSON.stringify(merchantURL));

  try {
    const response = await fetch(process.env.API_URL+"bookingBizum",{
      method: 'POST',
      body: postdata
    });

    if (!response.ok) {
      return {error:2203, data:''};
    }

    const jsonresponse = await response.json();
    if (!jsonresponse.success) {
      return {error:jsonresponse.error, data:'', debug:jsonresponse.debug}
    }

    return {error:0, data:jsonresponse.data, debug:jsonresponse.debug}

  } catch (error) {
    console.error(error);
    return {error:2203, data:''}
  }
}


